'use strict'
const login = {
    btns: document.querySelectorAll('.login__action__btn, .link__action'),
    toggle: function() {
        this.btns.forEach((btn) => {
            btn.addEventListener('click', () => {
                document.querySelector('.login__action__btn[data-target="'+btn.dataset.target+'"]').dataset.active = "true";
                document.querySelector('.login__action__btn:not([data-target="'+btn.dataset.target+'"])').dataset.active = "false";
                this.show('.login__tab#' + btn.dataset.target);
                this.hide('.login__tab:not(#' + btn.dataset.target + ')');
            });
        });
    },
    show: function(el) {
        let tab = document.querySelector(el);
        tab.dataset.active = "true";
        tab.ariaHidden = "false";
    },
    hide: function(el) {
        let tab = document.querySelector(el);
        tab.dataset.active = "false";
        tab.ariaHidden = "true";
    },
    init: function() {
        this.toggle();
    }
}
window.addEventListener('DOMContentLoaded', function(){
    if(document.querySelector('.login')) {
        login.init();
    }
});